module.exports = __webpack_public_path__ + "media/src/images/course-cover-default-b153657abbf991263d15664087534dd7.jpg";